import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import FormWrapper from '../FormWrapper';

const ResetPasswordForm = () => {
  const navigate = useNavigate();

  const [resetProcessId, setResetProcessId] = useState<string | null>(null);
  const [verificationCode, setVerificationCode] = useState<string | null>(null);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const storedId = localStorage.getItem('resetProcessId');
    const storedCode = localStorage.getItem('resetPasswordCode');

    if (storedId && storedCode) {
      setResetProcessId(storedId);
      setVerificationCode(storedCode);
    } else {
      setError('خطا: اطلاعات کافی برای تنظیم رمز عبور جدید موجود نیست. لطفاً مراحل بازیابی را مجدداً طی کنید.');
      setTimeout(() => navigate('/forgot-password'), 3000);
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    if (!resetProcessId || !verificationCode) {
      setError('خطا: اطلاعات بازیابی موجود نیست. لطفاً مجدداً درخواست دهید.');
      setLoading(false);
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('رمزهای عبور با هم مطابقت ندارند.');
      setLoading(false);
      return;
    }

    if (newPassword.length < 8) {
      setError('رمز عبور باید حداقل 8 کاراکتر باشد.');
      setLoading(false);
      return;
    }

    try {
      const response = await fetch('https://api.neontradepro.com/auth/password-reset/verify', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: resetProcessId, code: verificationCode, password: newPassword }),
      });

      const data = await response.json();
      if (response.ok) {
        setMessage('رمز عبور شما با موفقیت تغییر یافت. به صفحه ورود هدایت می‌شوید...');
        setNewPassword('');
        setConfirmPassword('');
        localStorage.removeItem('resetProcessId');
        localStorage.removeItem('resetPasswordCode');
        localStorage.removeItem('resetPasswordEmail');
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } else {
        let errorMessage = 'مشکلی در تغییر رمز عبور پیش آمد. لطفاً دوباره تلاش کنید.';
        if (data.detail) {
          if (typeof data.detail === 'string') {
            errorMessage = data.detail;
          } else if (typeof data.detail === 'object' && data.detail.msg) {
            errorMessage = data.detail.msg;
          } else if (Array.isArray(data.detail) && data.detail.length > 0) {
            errorMessage = data.detail.map(err => err.msg || err.detail || 'خطای ناشناخته').join('، ');
          } else {
            errorMessage = JSON.stringify(data.detail);
          }
        }
        setError(errorMessage);
      }
    } catch (err) {
      setError((err instanceof Error ? err.message : 'خطا در ارتباط با سرور. لطفاً بعداً دوباره تلاش کنید.'));
    } finally {
      setLoading(false);
    }
  };

  if (!resetProcessId || !verificationCode) {
    return (
      <FormWrapper title="تنظیم رمز عبور جدید" subtitle="خطا" currentStep={3} totalSteps={3}>
        <div className="error-message">{error}</div>
      </FormWrapper>
    );
  }

  return (
    <FormWrapper
      title="تنظیم رمز عبور جدید"
      subtitle={`رمز عبور جدید خود را وارد کنید.`}
      currentStep={3}
      totalSteps={3}
    >
      <form onSubmit={handleSubmit} autoComplete="off">
        {message && <div className="success-message">{message}</div>}
        {error && <div className="error-message">{error}</div>}

        <div className="input-group">
          <label htmlFor="newPassword">رمز عبور جدید</label>
          <input
            type={showPassword ? "text" : "password"}
            id="newPassword"
            name="newPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="رمز عبور جدید"
            required
            disabled={loading}
            autoFocus
          />
        </div>

        <div className="input-group">
          <label htmlFor="confirmPassword">تکرار رمز عبور جدید</label>
          <input
            type={showPassword ? "text" : "password"}
            id="confirmPassword"
            name="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="تکرار رمز عبور جدید"
            required
            disabled={loading}
          />
        </div>

        <div className='input-group' style={{ marginTop: '0.5rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', direction: 'rtl' }}>
          <input
              type="checkbox"
              id="showPassword"
              checked={showPassword}
              onChange={() => setShowPassword(!showPassword)}
              style={{ width: 'auto', marginLeft: '0.5rem' }}
          />
          <label htmlFor="showPassword" style={{ fontWeight: 'normal', fontSize: '0.875rem', marginRight: '0.25rem' }}>نمایش رمز عبور</label>
        </div>

        <button type="submit" className="main-btn" disabled={loading} style={{width: '100%', marginTop: '1rem'}}>
          {loading ? 'در حال ذخیره...' : 'تغییر رمز عبور'}
        </button>

        <div className="form-footer">
            <a href="#" onClick={(e) => { e.preventDefault(); navigate('/login'); }} style={{cursor: 'pointer'}}>
              بازگشت به صفحه ورود
            </a>
        </div>
      </form>
    </FormWrapper>
  );
};

export default ResetPasswordForm;